import request from '@/plugins/axios'


//上传图片
export function uploadFile(data){
    return request({
        url:'/sys/file/upload',
        method:'post',
        data
    })
}

// export function uploadEditUploadImg(file) {
//     let formData = new FormData();
//     formData.append("file", file);
//     return request({
//         url:'/sys/file/upload',
//         method:'post',
//         data:formData,
//         config : {
//             headers: {
//                 'Content-Type': 'multipart/form-data'
//             }
//         }
//     })
// }
export function uploadEditUploadImg(file,type) {
    let formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);
    return request({
      url:'/sys/file/upload',
      method:'post',
      data:formData,
      config : {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
    })
  }





